// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as UseSafeTimeout from "../../../../node_modules/@makerinc/use-safe-timeout/lib/es6_global/src/UseSafeTimeout.bs.js";
import * as ReactDOMUtils$Showside from "./ReactDOMUtils.bs.js";
import * as ScrollRestoration$Showside from "./ScrollRestoration.bs.js";
function ScrollLock(Props) {
  var enabledOpt = Props.enabled;
  var children = Props.children;
  var enabled = enabledOpt !== undefined ? enabledOpt : true;
  var ref = React.useRef(null);
  var match = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var safeTimeout = match.setTimeout;
  var onMouseDown = function (param) {
    if (enabled) {
      return ScrollRestoration$Showside.setScrollLock(ref);
    }
  };
  var onMouseUp = function (param) {
    if (enabled) {
      return safeTimeout(function (param) {
        ScrollRestoration$Showside.clearScrollLock(undefined);
      }, 100);
    }
  };
  return React.createElement("div", {
    ref: ReactDOMUtils$Showside.Ref.domRef(ref),
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp,
    onTouchEnd: onMouseUp,
    onTouchStart: onMouseDown
  }, children);
}
ScrollLock.displayName = "ScrollLock";
var make = ScrollLock;
export { make };
/* react Not a pure module */